import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';

/* istanbul ignore next */
class DeviceTypeFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.DEVICE_TYPE;
    this.displayName = 'Device Type';
    this.description = 'includes...';
    this.deviceTypeList = [
      { displayName: 'Room Alert 32S', id: 'RA32S' },
      { displayName: 'Room Alert 12S', id: 'RA12S' },
      { displayName: 'Room Alert 3S', id: 'RA3S' },
      { displayName: 'Room Alert 32E', id: 'RA32' },
      { displayName: 'Room Alert 12E', id: 'RA12' },
      { displayName: 'Room Alert 4E', id: 'RA4' },
      { displayName: 'Room Alert 3E', id: 'RA3' },
      { displayName: 'Room Alert 3 Wifi', id: 'RA3WIFI' },
      { displayName: 'Room Alert MAX', id: 'RAMAX' },
    ];
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'ANY of the following:',
      [OperatorTypes.NOT_EQUAL_TO]: 'NONE of the following',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue1(value) {
    return this.deviceTypeList.find((device) => device.id === value).displayName;
  }

  getValueSelectOptions() {
    return this.deviceTypeList.map((device) => ({
      label: device.displayName,
      value: device.id,
    })).sort((a, b) => {
      const nameA = a.label.toUpperCase();
      const nameB = b.label.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    return `Device type is ${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
        ? `ANY of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
          .map((filter) => this.getDisplayValue1(filter.value1))
          .join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
        ? ` NONE of ${filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
          .map((filter) => this.getDisplayValue1(filter.value1))
          .join(', ')
        };`
        : ''
    }`;
  }
}
export default DeviceTypeFacet;
